import { z } from "zod";
import { CURRENCIES } from "./money.js";

/** Contratti HTTP di saldi e pareggi. Importi in centesimi interi, come ovunque. */

export const memberBalanceResponseSchema = z.object({
  memberId: z.string(),
  displayName: z.string(),
  /** Positivo: gli devono. Negativo: deve. Zero: in pari. */
  balanceCents: z.number().int(),
  /** `true` se la persona è stata tolta dal gruppo ma ha ancora conti aperti. */
  removed: z.boolean(),
});
export type MemberBalanceResponse = z.infer<typeof memberBalanceResponseSchema>;

export const transferResponseSchema = z.object({
  fromMemberId: z.string(),
  fromDisplayName: z.string(),
  toMemberId: z.string(),
  toDisplayName: z.string(),
  amountCents: z.number().int().positive(),
});
export type TransferResponse = z.infer<typeof transferResponseSchema>;

export const groupBalancesResponseSchema = z.object({
  currency: z.enum(CURRENCIES),
  balances: z.array(memberBalanceResponseSchema),
  /** I pagamenti suggeriti per pareggiare tutto. */
  transfers: z.array(transferResponseSchema),
  /** Il saldo di chi ha fatto la richiesta. `null` se non è membro. */
  myBalanceCents: z.number().int().nullable(),
  /** Quante persone non sono in pari. */
  unsettledCount: z.number().int().nonnegative(),
});
export type GroupBalancesResponse = z.infer<typeof groupBalancesResponseSchema>;

export const createSettlementRequestSchema = z.object({
  fromMemberId: z.string().min(1),
  toMemberId: z.string().min(1),
  amountCents: z.number().int().positive("L'importo dev'essere maggiore di zero"),
  currency: z.enum(CURRENCIES),
  /** ISO 8601. Assente significa adesso. */
  settledAt: z.iso.datetime().optional(),
});
export type CreateSettlementRequest = z.infer<typeof createSettlementRequestSchema>;

export const settlementResponseSchema = z.object({
  id: z.string(),
  fromMemberId: z.string(),
  fromDisplayName: z.string(),
  toMemberId: z.string(),
  toDisplayName: z.string(),
  amountCents: z.number().int(),
  currency: z.enum(CURRENCIES),
  settledAt: z.string(),
  createdAt: z.string(),
});
export type SettlementResponse = z.infer<typeof settlementResponseSchema>;
